import { create } from 'zustand';
import { WidgetViewState } from '@/components/widget/WidgetOpeningManager/types';
import type { WidgetUIStore } from '@/types/widget';
import { ChannelOptions } from '@/types/widgetConfig';

// Opening trigger types - moved from WidgetOpeningManager
export enum WidgetOpeningType {
  POPUP_MESSAGE_CLICK = 'POPUP_MESSAGE_CLICK',
  WIDGET_BUTTON_CLICK = 'WIDGET_BUTTON_CLICK',
}

export const useWidgetUIStore = create<WidgetUIStore>((set, get) => ({
  // Initial state - removed isWidgetOpen, using currentView as single source of truth
  isLoading: false,
  error: null,
  pendingMessage: null,
  autoSendOnOpen: false,
  currentView: WidgetViewState.MINIMIZED,
  currentChannelDetailType: null,

  // Helper functions for state checks
  isWidgetVisible: () => get().currentView !== WidgetViewState.MINIMIZED,
  isWidgetMinimized: () => get().currentView === WidgetViewState.MINIMIZED,

  // Actions
  actions: {
    toggleWidget: () =>
      set((state) => ({
        currentView:
          state.currentView === WidgetViewState.MINIMIZED
            ? WidgetViewState.LANDING_PAGE
            : WidgetViewState.MINIMIZED,
      })),

    setIsLoading: (loading: boolean) =>
      set({
        isLoading: loading,
      }),

    setError: (error: string | null) =>
      set({
        error,
      }),

    clearError: () =>
      set({
        error: null,
      }),

    openWidgetWithMessage: (message: string) =>
      set({
        currentView: WidgetViewState.CHAT_WINDOW,
        pendingMessage: message,
        autoSendOnOpen: true,
      }),

    clearPendingMessage: () =>
      set({
        pendingMessage: null,
        autoSendOnOpen: false,
      }),

    setCurrentView: (view: WidgetViewState) =>
      set({
        currentView: view,
      }),

    setChannelDetailType: (channelType: keyof ChannelOptions | null) =>
      set({
        currentChannelDetailType: channelType,
      }),
  },
}));
